import './styles.scss';

import * as echarts from 'echarts/core';

import { BarChart, LineChart, PieChart, ScatterChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TitleComponent, ToolboxComponent, TooltipComponent } from 'echarts/components';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { LegacyRef, forwardRef } from 'react';

import { CanvasRenderer } from 'echarts/renderers';
import { EChartsReactProps } from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { getClasses } from '@/utils';

echarts.use([
  GridComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LineChart,
  BarChart,
  PieChart,
  ScatterChart,
  CanvasRenderer,
  LabelLayout,
  UniversalTransition,
]);

export type ChartProps = {} & EChartsReactProps;

const Chart = forwardRef(({ className, ...eChartProps }: ChartProps, ref: LegacyRef<ReactEChartsCore>): JSX.Element => {
  return (
    <div className={getClasses('Chart', className)}>
      <ReactEChartsCore {...eChartProps} echarts={echarts} ref={ref} />
    </div>
  );
});

export default Chart;
